<template>
  <multiselect
    v-model="model"
    :options="options"
    :placeholder="$t('formCsvDelimiterPlaceholder')"
    deselect-label=""
    :allow-empty="false"
    :loading="isLoading"
    :class="stateClass" />
</template>

<script>
import DropdownMixin from '@/mixins/DropdownMixin';

export default {
  mixins: [ DropdownMixin ],
  methods: {
    findOptions() {
      return new Promise(resolve => resolve([ ';', ',', '|' ]));
    },
  }
};
</script>
